import buildSlider from './slider';

const options = {
  align: 'start',
  containScroll: 'trimSnaps',
  inViewThreshold: 0.2,
  slidesToScroll: 1,
};

buildSlider('.slider-timeline', options);
